import React from 'react';
import useCustomer from '../../../hooks/use-customer';
import AdminUserAccountForm from '../admin-user-account-form';
import AdminUserAddressForm from '../admin-user-address-form';
import AdminUserRoleForm from '../admin-user-role-form';
import AdminUserPermissionsForm from '../admin-user-permissions-form';
import AdminUserStatusForm from '../admin-user-status-form';
import AdminUserVidaForm from '../admin-user-vida-form';
import Link from '../../link';
import AdminUserLogInAs from '../admin-user-log-in-as';
import AdminUserRetailerForm from '../admin-user-retailer-form';
import AdminUserIsEmailVerifiedForm from "../admin-user-is-email-verified-form";
import AdminUserIsTinValidatedForm from "../admin-user-is-tin-validated-form";
import AdminUserVidaAccessStatusForm from "../admin-user-vida-access-status-form";
import AdminUserResendEmailVerificationForm from "../admin-user-resend-email-verification";
import AdminUserSendPasswordReset from "../admin-user-send-password-reset";
import AdminUserNoteForm from "../admin-user-note-form";

interface Props {
  id: string;
}

const AdminUserEditor: React.FC<Props> = ({ id }) => {
  const customer = useCustomer(id);

  if (!customer) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="content">
        <div className="action-links">
          <Link href={`/admin/users/${id}/orders`}>
            <a>
              <i className="fas fa-clipboard-list" /> Order History
            </a>
          </Link>
          <Link href={`/admin/users/${id}/requests`}>
            <a>
              <i className="fas fa-concierge-bell" /> Help Requests
            </a>
          </Link>
          <Link href={`/admin/users/${id}/software`}>
            <a target="_blank">
              <i className="fas fa-arrow-alt-circle-down" /> Software Orders
            </a>
          </Link>
          <Link href={`/admin/users/${id}/subscriptions`}>
            <a target="_blank">
              <i className="fas fa-clipboard" /> Subscription Orders
            </a>
          </Link>
          <Link href={`/admin/users/${id}/buy-sell`}>
            <a>
              <i className="fas fa-exchange-alt" /> Buy/Sell
            </a>
          </Link>
          <AdminUserLogInAs id={id} />
        </div>
        <AdminUserSendPasswordReset customer={customer.customer!} />
        <AdminUserAccountForm customer={customer.customer!} />
        <AdminUserAddressForm customer={customer.customer!} />
        <AdminUserStatusForm customer={customer.customer!} />
        <AdminUserResendEmailVerificationForm customer={customer.customer!} />
        <AdminUserIsEmailVerifiedForm customer={customer.customer!} />
        <AdminUserRetailerForm customer={customer.customer!} />
        <AdminUserRoleForm customer={customer.customer!} />
        <AdminUserPermissionsForm customer={customer.customer!} />
        <AdminUserVidaForm customer={customer.customer!} />
        <AdminUserVidaAccessStatusForm customer={customer.customer!} />
        <AdminUserIsTinValidatedForm customer={customer.customer!} />
        <AdminUserNoteForm customer={customer.customer!} />
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .action-links {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          margin-bottom: 1rem;
          text-align: left;
        }

        .action-links :global(a) {
          color: #333;
          text-decoration: none;
          transition: all 0.2s linear;
          cursor: pointer;
        }

        .action-links :global(a:not(:last-child)) {
          margin-right: 1rem;
        }

        .action-links :global(a:hover) {
          color: #707070;
        }

        .content :global(form) {
          margin-bottom: 2rem;
        }

        .content :global(h2) {
          margin: 0 0 1rem;
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
        }

        .content :global(p) {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          margin: 0;
        }

        .content :global(.account-dates) {
          margin-bottom: 1rem;
        }
      `}</style>
    </React.Fragment>
  );
};

export default AdminUserEditor;
